import React, { useCallback, useEffect, useMemo, useState } from 'react';
import classnames from 'classnames';

import styles from './Pagination.module.css';


function Pagination(props) {
  const { page, totalPages, onPageChange } = props;
  const [pageArray, setPageArray] = useState([]);

  const setPageOptions = useCallback(() => {
    const array = [];
    for (let i = 0; i < totalPages; i++) {
      array.push(i + 1);
    }
    setPageArray(array);
  }, [totalPages]);

  const handleClick = useCallback((e) => {
    onPageChange(e);
  }, [onPageChange]);


  const renderPaginationItem = useCallback((index) => (
    <li
      key={String(index)}
      className={classnames(
        styles.paginationListItem,
        { [styles.activeItem]: index === page + 1 }
      )}
      value={index}
      onClick={handleClick}
    >
      {index}
    </li>
  ), [handleClick, page]);

  const renderPreviousPages = useMemo(() => {
    const previousPages = [];
    for (let i = page - 1; i > Math.max(2, page - 2); i--) {
      previousPages.push(renderPaginationItem(i));
    }

    return previousPages.reverse();
  }, [page, renderPaginationItem]);

  const renderNextPages = useMemo(() => {
    const nextPages = [];
    for (let i = page + 1; (i >= 1) && (i <= Math.min(totalPages - 1, page + 3)); i++) {
      // first page is always rendered
      if (i === 1) {
        continue;
      } else {
        nextPages.push(renderPaginationItem(i));
      }
    }

    return nextPages;
  }, [page, renderPaginationItem, totalPages]);

  useEffect(() => {
    setPageOptions();
  }, [setPageOptions]);

  if (totalPages <= 1) {
    return null;
  }

  if (totalPages < 10) {
    return (
      <div className={styles.paginationContainer}>
        <ul className={styles.paginationListContainer}>
          {pageArray.map((pageIndex) => renderPaginationItem(pageIndex))}
        </ul>
      </div>
    );
  }

  return (
    <div className={styles.paginationContainer}>
      <ul className={styles.paginationListContainer}>
        {renderPaginationItem(1)}
        {page - 3 > 0 && <span className="prev">...</span>}
        {renderPreviousPages}
        {page > 1 && renderPaginationItem(page)}
        {renderNextPages}
        {page + 3 < totalPages && <span className="next">...</span>}
        {renderPaginationItem(totalPages)}
      </ul>
    </div>
  );
}

export default Pagination;
